import { schema } from 'normalizr';

const SubscriptionHistorySchema = {
	SUBSCRIPTIONHISTORYS: new schema.Array(new schema.Entity('subscriptionhistory', {}, { idAttribute: 'id' }))
};

export default SubscriptionHistorySchema;